import React, { useEffect, useRef, useState } from "react";
import { TriangleAlert, Trash2 } from "lucide-react";
import ModalPortal from "../../utils/ModalPortal";

const ArchiveDocumentDialog = ({ onCancel, onConfirm }) => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => { active.current = false; };
  }, []);
  const cancel = () => { if (!inFlight.current) onCancel(); };
  const confirm = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setPending(true);
    setError('');
    try {
      const result = await onConfirm();
      if (active.current && result !== false) onCancel();
    } catch (failure) {
      if (active.current) setError(failure.code === 'document-save-failed'
        ? failure.message : 'Unable to archive this document. Please try again.');
    } finally {
      inFlight.current = false;
      if (active.current) setPending(false);
    }
  };
  return (
  <ModalPortal isOpen>
    <div className="modal" onClick={cancel}>
      <div
        aria-labelledby="archive-document-title"
        aria-describedby="archive-document-description"
        aria-modal="true"
        aria-busy={pending}
        className="modal-content archive-document-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <div className="archive-document-modal-heading">
          <TriangleAlert aria-hidden="true" size={24} />
          <h3 className="modal-title" id="archive-document-title">
            Archive this document?
          </h3>
        </div>
        <p className="archive-document-modal-description" id="archive-document-description">
          Archiving hides the document and its session transcript from Featherglass. They remain stored according to your organization&apos;s retention policy.
        </p>
        {error && <p role="alert">{error}</p>}
        <div className="modal-button-container">
          <button className="button-cancel-secondary" onClick={cancel} disabled={pending}>
            Cancel
          </button>
          <button className="button-delete" onClick={confirm} disabled={pending}>
            <Trash2 aria-hidden="true" size={15} /> {pending ? 'Archiving…' : 'Archive document'}
          </button>
        </div>
      </div>
    </div>
  </ModalPortal>
  );
};

// Unmount on close so a reopened dialog starts with fresh request/error state.
const ArchiveDocumentConfirmModal = ({ isOpen, ...props }) => isOpen ? <ArchiveDocumentDialog {...props} /> : null;

export default ArchiveDocumentConfirmModal;
